<template>
  <DBox
    :id="'cm-royalty-royalty_account-main_contact'"
    :addButton="false"
    :addLink="mainContact.contact_id ? false : true"
    :addLinkLabel="'Add a Contact'"
    @add_click="addContactRelationClick"
  >
    <div
      v-if="mainContact.contact_id"
      class="fc2 fc2-row ut-flex company-name-content"
    >
      <label class="fc2-label txtov">{{
        $dft.snakeCaseToWords("company_name")
      }}</label>

      <div class="ut-flex ut-link ut-text-accent5 company-name-text">
        <span
          @click.stop="(e) => onSelectContact(mainContact)"
          class="company-name"
          >{{ mainContact.company_name }}</span
        >
        <div @click="addContactRelationClick()" class="no-label">
          <img
            src="static/icons/toggle.svg"
            class="dt-icon v5 s2"
            alt="name"
            title="Company Name"
          />
        </div>
      </div>
    </div>

    <TextField2
      v-if="mainContact.address1"
      :disabled="'disabled'"
      :id="'address1'"
      :placeholder="$t('address1')"
      :label="$t('address')"
      :value="mainContact.address"
      textarea
    />

    <TextField2
      :disabled="'disabled'"
      :id="'phone1'"
      :placeholder="$t('phone')"
      :label="$t('phone')"
      v-if="mainContact.phone1"
      :value="mainContact.phone1"
    />
    <!-- <TextField2
      :disabled="'disabled'"
      :id="'fax1'"
      v-if="mainContact.fax1"
      :placeholder="$t('fax')"
      :label="$t('fax')"
      :value="mainContact.fax1"
    /> -->
    <TextField2
      bb="none"
      :disabled="'disabled'"
      :id="'email'"
      :placeholder="$t('email')"
      :label="$t('email')"
      v-if="mainContact.email1"
      :value="mainContact.email1"
    />
  </DBox>
</template>

<script>
export default {
  components: {},
  props: ["selectedAccountDetails"],

  computed: {
    mainContact: function () {
      if (this.selectedAccountDetails.contact) {
        this.selectedAccountDetails.contact.address = `${this.selectedAccountDetails?.contact?.address1}\n${this.selectedAccountDetails?.contact?.postalcode}\n${this.selectedAccountDetails?.contact?.country}`;
      }

      return this.selectedAccountDetails.contact || {};
    },
  },

  methods: {
    addContactRelationClick: function () {
      this.$emit("add_click", "add_main_contact_form");
    },
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onSelectContact: function (mainContact) {
      this.$emit("selected", mainContact.contact_id);
    },
  },
};
</script>
<style lang="scss">
.cm-royalty-royalty_account-main_contact {
  .company-name-text {
    padding-left: 30px !important;
  }

  .fc2 {
    --bb: none !important;
    textarea.fc-control {
      &:hover {
        --fc2-bc: #fff !important;
        --fc2-bdc: #fff !important;
      }
    }
    input.fc-control {
      &:hover,
      &:hover:not(.company-name) {
        --fc2-bc: #fff !important;
        --fc2-bdc: #fff !important;
      }
    }
   
  }
 .fc2-label {
      padding-bottom: 5px !important;;
    }
  .company-name-content {
    border-bottom: 1px solid var(--sprt-85) !important;
    .company-name {
      width: 100%;
    }
  }

  .fc2.disabled {
    --fc2-bc: #fff;
  }

  .fc2-row {
    --bb: 1px solid var(--sprt-85);

    height: 30px;
    border-bottom: var(--bb);
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;
    }

    .no-label {
      margin-top: 5px;
    }
  }
}
</style>